import React, { useState, useEffect, Fragment } from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
// import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EastIcon from "@mui/icons-material/East";
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, MenuItem, InputLabel, Select } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import moment from 'moment';

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { styled } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";


import { useForm } from "react-hook-form";

// import CameraComponent from '../CameraComponent';
import CameraAddMore from '../CameraAddMore';

// const FACING_MODE_USER = { facingMode: 'user' }; // Front Camera
// const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } }; // Back Camera

// const AccessoryItems = [
//   { id: 1, displayFormat: 'A', name: 'เครื่องเสียง', image: 'assets/front_left.png' },
//   { id: 2, displayFormat: 'A', name: 'ยางอะไหล่', image: 'assets/front.png' },
//   { id: 3, displayFormat: 'A', name: 'กล้องหน้ารถ', image: 'assets/front_right.png' },
//   { id: 4, displayFormat: 'A', name: 'ล้อแม็ก', image: 'assets/back_left.png' },
// ];
// // ถ้าเกิน 3 เอาแถวละ 3 ถ้าไม่ถึง 3 ขยายให้เต็มบรรทัด
// const itemsCount = AccessoryItems.length>3?3:AccessoryItems.length;
// const itemsCol = Math.floor(12/itemsCount);


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Img = styled("img")({
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    height: 160,
});

const starStyle = {color:'red',fontWeight:'bold',marginLeft:'2px',marginBottom:'0px'};

export default function AccessoryForm({ onSave, dataStep, saveAndBack, btnLoading }) {
    const [gender, setGender] = useState("");
    // const [birthday, setBirthday] = useState("");
    // const [education_qual, setEducation_qual] = useState('');
    // const [educationList, setEducationList] = useState([
    //     "ต่ำกว่ามัธยมศึกษาตอนปลาย / ปวช.",
    //     "มัธยมศึกษาตอนปลาย / ปวช.",
    //     "อนุปริญญา / ปวส.",
    //     "ปริญญาตรี",
    //     "ปริญญาโท หรือสูงกว่า"
    // ]);
    // const [open, setOpen] = React.useState(false);

    const [imagesAudioEquipment, setImagesAudioEquipment] = React.useState([]);
    const [openAudioEquipment, setOpenAudioEquipment] = React.useState(false);
    const [has_audio, setHas_audio] = useState("1");

    const [imagesSpareTire, setImagesSpareTire] = React.useState([]);
    const [openSpareTire, setOpenSpareTire] = React.useState(false);
    const [has_spareTire, setHas_spareTire] = useState("1");

    const [imagesCarCAM, setImagesCarCAM] = React.useState([]);
    const [openCarCAM, setOpenCarCAM] = React.useState(false);
    const [has_carCAM, setHas_carCAM] = useState("1");

    const [imagesMaxWheel, setImagesMaxWheel] = React.useState([]);
    const [openMaxWheel, setOpenMaxWheel] = React.useState(false);
    const [has_maxWheel, setHas_maxWheel] = useState("1");

    const [previousData, setPreviousData] = useState(null);
    const [capturedImages, setCapturedImages] = useState(null);
    const [inputTextImagesData, setInputTextImagesData] = useState([]);
    const [inputObjIDImages, setInputObjIDImages] = useState([]);

    const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const [user, setUser] = useState(null);

    function handleTextChange(e) {
      const { id, value } = e.target;
        console.log("handleTextChange in Accessory", inputTextImagesData);
      // setInputTextImagesData(prev => ({ ...prev, [id]: value }));    // code นี้มันทำให้ค่า inputTextImagesData กลายเป็น object จึงใช้ไม่ได้
      // console.log("inputTextImagesData",inputTextImagesData);
      setInputTextImagesData(prev => {
          // แปลง id (ที่อาจเป็น string) ให้เป็นตัวเลขสำหรับใช้เป็น index
          const targetIndex = Number(id);

          // ใช้ (prev ?? []) เพื่อป้องกัน error หาก state เริ่มต้นเป็น null/undefined
          // .map() จะสร้าง array ใหม่เสมอ (หลักการ Immutability ของ React)
          return (prev ?? []).map((item, index) => {
            // ตรวจสอบว่าใช่ index ที่เราต้องการแก้ไขหรือไม่
            if (index === targetIndex) {
              // ถ้าใช่ ให้คืนค่า value ใหม่จาก TextChange
              return value;
            }
            // ถ้าไม่ใช่ index ที่ต้องการแก้ ก็คืนค่าเดิมไป
            return item;
          });
        });
    }


    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        // reset form with previousData data
        reset(previousData);
        // console.log("reset", previousData);
    }, [previousData]);

    const onSubmit = (data) => {
        console.log("onSubmit", data);
        // console.log("inputTextImagesData",inputTextImagesData);
        data.capturedImages = capturedImages;
        data.capturedTextImages = inputTextImagesData;
        data.capturedObjIDImages = inputObjIDImages;
            //// ในกรณีที่กดย้อนกลับมา แล้วกดไปต่อ (โดยไม่ได้เปิด popup ขึ้นมาดู) มันจะไม่ได้ set ค่า มี/ไม่มี ด้วย
            //// จึงทำการ set ค่าจาก state อีกครั้ง ก่อนจะ submit ค่าไป save
            data.has_audio = has_audio;
            data.has_spareTire = has_spareTire;
            data.has_carCAM = has_carCAM;
            data.has_maxWheel = has_maxWheel;

            // console.log("imagesSpareTire[0]", imagesSpareTire[0], "has_spareTire", has_spareTire);
            // if(!imagesSpareTire[0]){
            //     // console.log("if");
            //     alert("กรุณาถ่าย หรือ อัพโหลด รูปยางอะไหล่ ก่อนไปยังขั้นตอนถัดไป");
            //     return;
            // }
            if(!has_spareTire){
                console.log("has_spareTire has undefined");
                alert("กรุณาถ่าย หรือ อัพโหลด รูปยางอะไหล่ ก่อนไปยังขั้นตอนถัดไป");
                return;
            }else if(has_spareTire == 1){
                if(!imagesSpareTire[0]){
                    console.log("images not have");
                    alert("กรุณาถ่าย หรือ อัพโหลด รูปยางอะไหล่ ก่อนไปยังขั้นตอนถัดไป");
                    return;
                }
            }
            // console.log("imagesCarCAM[0]", imagesCarCAM[0], "has_carCAM", has_carCAM);
            if(!has_carCAM){
                console.log("has_carCAM has undefined");
                alert("กรุณาถ่าย หรือ อัพโหลด กล้องหน้ารถ ก่อนไปยังขั้นตอนถัดไป");
                return;
            }else if(has_carCAM == 1){
                if(!imagesCarCAM[0]){
                    console.log("images not have");
                    alert("กรุณาถ่าย หรือ อัพโหลด กล้องหน้ารถ ก่อนไปยังขั้นตอนถัดไป");
                    return;
                }
            }

        onSave(data);
    };

    const handleCapture = (capturedImages) => {
        console.log("handleCapture",capturedImages);
        console.log("handleCapture dataStep",dataStep);
        setValue('capturedImages', capturedImages);
        setCapturedImages(capturedImages);
        console.log("handleCapture inputTextImagesData",inputTextImagesData);
        setInputTextImagesData((prev) => {
            const newObjImage = [...prev];
            // console.log("newObjImage",capturedImages.length,newObjImage);
            newObjImage[capturedImages.length-1] = ''; // ==> เอา default เป็น '' ไปก่อน
            return newObjImage;
        });
        //// ต้อง set default value สำหรับ objID ของรูปใหม่ด้วย ////
        console.log("handleCapture inputObjIDImages",inputObjIDImages);
        setInputObjIDImages((prev) => {
            const newObjImage = [...prev];
            // console.log("newObjImage",capturedImages.length,newObjImage);
            newObjImage[capturedImages.length-1] = ''; // ==> เอา default เป็น '' ไปก่อน
            return newObjImage;
        });
    }

    const handleRemoveImage = (index, newImages, newTextImages, newObjIDImages) => {
        console.log("handleRemoveImage index", index);
        console.log("newImages", newImages, "newTextImages", newTextImages,"inputObjIDImages",inputObjIDImages);
            console.log("type newTextImages", typeof newTextImages);
        setCapturedImages((newImages) => newImages.filter((_, i) => i !== index));
        setInputTextImagesData((newTextImages) => newTextImages.filter((_, i) => i !== index));
        // setInputTextImagesData((prev) => {
        //     console.log("input prev",prev);
        //     prev.filter((_, i) => i !== index)
        // });
            console.log("newTextImages",newTextImages);
            console.log("inputTextImagesData",inputTextImagesData);
        setInputObjIDImages((prev) => prev.filter((_, i) => i !== index));


        setValue('capturedImages', capturedImages);
        // setCapturedImages(newImages);
        // setValue('capturedTextImages', newTextImages);
        // setInputTextImagesData(newTextImages);
    }

    // const handleRemoveImage = (index, newImages) => {
    //     // console.log("handleRemoveImage index", index, "newImages", newImages);
    //     setValue('capturedImages', newImages);
    //     setCapturedImages(newImages);
    // }

    const handleBack = () => {
        // console.log("new handleBack", data);
        // console.log("capturedImages",capturedImages);
        // console.log("inputTextImagesData",inputTextImagesData);
        // console.log("handleBack datastep",dataStep);
        // setCapturedImages(dataStep.capturedImages);
        setCapturedImages(capturedImages);
        // setValue('imageSrc', imageSrc);
        // setValue('capturedImages', capturedImages);


        const data = { 
            capturedImages : capturedImages,
            capturedTextImages : inputTextImagesData,
            capturedObjIDImages : inputObjIDImages,
            imagesAudioEquipment : imagesAudioEquipment,
            imagesSpareTire : imagesSpareTire,
            imagesCarCAM : imagesCarCAM,
            imagesMaxWheel : imagesMaxWheel,
            has_audio: has_audio,
            has_spareTire: has_spareTire,
            has_carCAM: has_carCAM,
            has_maxWheel: has_maxWheel,
        }

        // console.log("will saveAndBack",data);
        saveAndBack(data);
    }

    function getData() {
        console.log("getData 3",dataStep);
        if (dataStep !== "") {
            setPreviousData({
                capturedImages: dataStep.capturedImages,
                capturedTextImages: dataStep.capturedTextImages,
                capturedObjIDImages: dataStep.capturedObjIDImages,
                imagesAudioEquipment: dataStep.imagesAudioEquipment && dataStep.imagesAudioEquipment.length > 0 ?
                                        [dataStep.imagesAudioEquipment[0]] : null,
                imagesSpareTire: dataStep.imagesSpareTire && dataStep.imagesSpareTire.length > 0 ?
                                        [dataStep.imagesSpareTire[0]] : null,
                imagesCarCAM: dataStep.imagesCarCAM && dataStep.imagesCarCAM.length > 0 ?
                                        [dataStep.imagesCarCAM[0]] : null,
                imagesMaxWheel: dataStep.imagesMaxWheel && dataStep.imagesMaxWheel.length > 0 ?
                                        [dataStep.imagesMaxWheel[0]] : null,
    //             lastname: dataStep.lastname,
    //             gender: dataStep.gender,
                has_audio: dataStep.has_audio,
                has_spareTire: dataStep.has_spareTire,
                has_carCAM: dataStep.has_carCAM,
                has_maxWheel: dataStep.has_maxWheel,
            })

            setCapturedImages(dataStep.capturedImages);
            setInputTextImagesData(dataStep.capturedTextImages);
            setInputObjIDImages(dataStep.capturedObjIDImages);
            if(dataStep.imagesAudioEquipment && dataStep.imagesAudioEquipment.length > 0){
                setImagesAudioEquipment([dataStep.imagesAudioEquipment[0]]);
            }
            if(dataStep.imagesSpareTire && dataStep.imagesSpareTire.length > 0){
                setImagesSpareTire([dataStep.imagesSpareTire[0]]);
            }
            if(dataStep.imagesCarCAM && dataStep.imagesCarCAM.length > 0){
                setImagesCarCAM([dataStep.imagesCarCAM[0]]);
            }
            if(dataStep.imagesMaxWheel && dataStep.imagesMaxWheel.length > 0){
                setImagesMaxWheel([dataStep.imagesMaxWheel[0]]);
            }
        // console.log("imagesAudioEquipment",imagesAudioEquipment);
    //         console.log(dataStep);
            setHas_audio(dataStep.has_audio !== null ? dataStep.has_audio : "0");
            setHas_spareTire(dataStep.has_spareTire !== null ? dataStep.has_spareTire : "0");
            setHas_carCAM(dataStep.has_carCAM !== null ? dataStep.has_carCAM : "0");
            setHas_maxWheel(dataStep.has_maxWheel !== null ? dataStep.has_maxWheel : "0");
    //         setGender(dataStep.gender);
    //         setBirthday(dataStep.birthday);
    //         setEducation_qual(dataStep.education_qual);
        }
    }


    function onImageChangeAudioEquipment(event) {
        let files = event.target.files;
        // console.log("files type", typeof(files), files);
        if(files.length>0){
            let reader = new FileReader();
            // console.log("reader type", typeof(reader), reader);
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesAudioEquipment([e.target.result]);
                // console.log("e.target.result",[e.target.result]);
                setValue('imagesAudioEquipment', [e.target.result]);
                // setImagesAudioEquipment([e.target.result]);
            };
        }
    }
    function onImageChangeSpareTire(event) {
        let files = event.target.files;
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesSpareTire([e.target.result]);
                setValue('imagesSpareTire', [e.target.result]);
            };
        }
    }
    function onImageChangeCarCAM(event) {
        let files = event.target.files;
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesCarCAM([e.target.result]);
                setValue('imagesCarCAM', [e.target.result]);
            };
        }
    }
    function onImageChangeMaxWheel(event) {
        let files = event.target.files;
        if(files.length>0){
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = (e) => {
                setImagesMaxWheel([e.target.result]);
                setValue('imagesMaxWheel', [e.target.result]);
            };
        }
    }

    const checkState = () => {
        console.log("checkState");
        console.log("previousData",previousData);
        console.log("has_audio",has_audio);
        console.log("has_spareTire",has_spareTire);
        console.log("has_carCAM",has_carCAM);
        console.log("has_maxWheel",has_maxWheel);
    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>


                    {/*<Button onClick={checkState}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                    >
                        check param
                    </Button> */}


                {/* เครื่องเสียง 
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesAudioEquipment.length > 0 ? "#73c088" 
                            : has_audio == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenAudioEquipment(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>เครื่องเสียง</div>
                    </Box>
                    {imagesAudioEquipment.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openAudioEquipment} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenAudioEquipment(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>เครื่องเสียง</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_audio}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_audio")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_audio("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_audio("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_audio == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeAudioEquipment}
                                        />
                                        {imagesAudioEquipment.length > 0 ? (
                                            imagesAudioEquipment.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenAudioEquipment(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>
                */}


                {/* ยางอะไหล่ */}
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesSpareTire.length > 0 ? "#73c088" 
                            : has_spareTire == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenSpareTire(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>ยางอะไหล่</div>
                    </Box>
                    {imagesSpareTire.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openSpareTire} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenSpareTire(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>ยางอะไหล่</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            {/* radio มี / ไม่มี */}
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_spareTire}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_spareTire")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_spareTire("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_spareTire("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_spareTire == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeSpareTire}
                                        />
                                        {imagesSpareTire.length > 0 ? (
                                            imagesSpareTire.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenSpareTire(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>


                {/* กล้องหน้ารถ */}
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            imagesCarCAM.length > 0 ? "#73c088" 
                            : has_carCAM == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenCarCAM(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3 }} />
                        <div>กล้องหน้ารถ</div>
                    </Box>
                    {imagesCarCAM.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openCarCAM} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenCarCAM(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>กล้องหน้ารถ</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            {/* radio มี / ไม่มี */}
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_carCAM}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_carCAM")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_carCAM("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_carCAM("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                    {
                        has_carCAM == 1?
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture onChange={onImageChangeCarCAM}
                                        />
                                        {imagesCarCAM.length > 0 ? (
                                            imagesCarCAM.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        :null
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenCarCAM(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>


                {/* ล้อแม็ก - ไม่ต้องถ่ายรูป */}
                <Grid
                    item xs={12} sm={12} container
                    direction="row" justifyContent="space-between"
                    alignItems="center" boxShadow={3}
                    sx={{ p: 3, mt: 3, ml: 2, cursor: "pointer",
                        backgroundColor: 
                            has_maxWheel == 1 ? "#73c088" 
                            : has_maxWheel == 0 ? "#73c088"
                            : null,
                    }}
                    onClick={() => setOpenMaxWheel(true)}
                >
                    <Box sx={{ display: "flex" }}>
                        <UploadFileIcon sx={{ mr: 3, visibility: 'hidden' }} />
                        <div>ล้อแม็ก</div>
                    </Box>
                    {imagesMaxWheel.length > 0 ? <CheckIcon /> : <CloseIcon />}
                </Grid>
                <Dialog
                    open={openMaxWheel} TransitionComponent={Transition}
                    fullWidth={true} maxWidth="sm"
                    keepMounted
                    onClose={() => setOpenMaxWheel(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        <div>ล้อแม็ก</div>
                        <div variant="subtitle2" sx={{ color: "#FF0000" }} >
                            {/* radio มี / ไม่มี */}
                            <RadioGroup
                                aria-labelledby="radio-audio-equipment-buttons-group"
                                value={has_maxWheel}
                                name="radio-audio-equipment-buttons-group"
                                {...register("has_maxWheel")}
                            >
                                <FormControlLabel label="มี"
                                    onChange={(event) => setHas_maxWheel("1")} value="1" control={<Radio />}
                                />
                                <FormControlLabel label="ไม่มี"
                                    onChange={(event) => setHas_maxWheel("0")} value="0" control={<Radio />}
                                />
                            </RadioGroup>
                        </div>
                    </DialogTitle>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={() => setOpenMaxWheel(false)}
                            endIcon={<EastIcon />}
                            sx={{ mt: 3, ml: 1 }}
                        >
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>


                    {/*
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="เครื่องเสียง"
                            control={<Checkbox {...register("has_Audio")} id="has_Audio" />} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="ยางอะไหล่"
                            control={<Checkbox {...register("has_sparePart")} id="has_sparePart" />} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="กล้องหน้ารถ"
                            control={<Checkbox {...register("has_carCam")} id="has_carCam" />} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel label="ล้อแม็ก"
                            control={<Checkbox {...register("has_wheels")} id="has_wheels" />} 
                        />
                    </Grid>
                    */}


                    {/*
                    <Grid item xs={12} sm={12}>
                        <button
                            className="btn btn-primary"
                            type="button"
                            // endIcon={<EastIcon />}
                            style={{marginTop:'24px',marginLeft:'8px',backgroundColor:'#1565c0'}}
                        >
                            เพิ่มรายการ
                        </button>
                    </Grid>
                    */}

                    <CameraAddMore btnText="เพิ่มรายการ" addTextLabel 
                        onTextChange={handleTextChange}
                        onCapture={handleCapture}
                        onRemoveImage={handleRemoveImage}
                        previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                        previousTextData={dataStep.capturedTextImages?dataStep.capturedTextImages:null}
                        previousObjID={dataStep.capturedObjIDImages?dataStep.capturedObjIDImages:null}
                        uploadAble={true}
                    />




                    

                </Grid>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >

                    <Button onClick={handleBack}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                    >
                        ย้อนกลับ
                    </Button>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        endIcon={<EastIcon />}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                        loading={btnLoading}
                        loadingPosition="start"
                    >
                        ถัดไป
                    </LoadingButton>

                    {/*
                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                        ย้อนกลับ
                    </Button>

                    <LoadingButton
                        type="submit"
                        loading={isLoading}
                        loadingPosition="end"
                        endIcon={<EastIcon />}
                        variant="contained"
                        sx={{ mt: 3, ml: 1 }}
                    >
                        สมัคร
                    </LoadingButton> 
                    */}
                    
                </Box>
            </form>
        </React.Fragment>
    );
}
